exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Ojp {\n    margin: 0 auto 20px auto;\n}\n", ""]);

// exports
exports.locals = {
	"mentorPreviewCard": "_2Ojp"
};